module.exports = __webpack_public_path__ + "static/img/course4.4789e4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/course4.png
// module id = AviK
// module chunks = 63